import Image from "next/image";

type CarouselNavigationProps = {
  onClickPrev: () => void;
  onClickNext: () => void;
};

export const CarouselNavigation = ({ onClickPrev, onClickNext }: CarouselNavigationProps) => {
  return (
    <div className="flex justify-center items-center gap-[15px]">
      <button onClick={onClickPrev} className="block md:absolute md:top-[50%] md:translate-y-[-50%] md:left-12 z-1">
        <Image
          width={48}
          height={48}
          alt="Arrow"
          src="https://front.com/webassets/rebrand/icon-arrow-carousel.svg"
          className="w-6 h-6 block rotate-180"
        />
      </button>
      <button onClick={onClickNext} className="block md:absolute md:top-[50%] md:translate-y-[-50%] md:right-12 z-1">
        <Image width={48} height={48} alt="Arrow" src="https://front.com/webassets/rebrand/icon-arrow-carousel.svg" className="w-6 h-6 block" />
      </button>
    </div>
  );
};
